import CountryConfig from "./countryConfig";

export default CountryConfig;